import { useSyncExternalStore } from "react";
import { outboxCounts } from "../ordering/outbox";
import { usePlatform } from "../provider";
import { useConnectionStatus } from "../realtime/hooks";
import { useOutbox, useRestaurantId } from "./use-order";

const always = () => () => {};

/** The platform's network flag (`network` adapter); true without one. */
export function useNetworkOnline(): boolean {
	const network = usePlatform().network;
	return useSyncExternalStore(
		network ? (listener) => network.subscribe(listener) : always,
		() => network?.isOnline() ?? true,
		() => true,
	);
}

/**
 * The offline banner (OP-17, P3-T29): `offline` when the device says it has
 * no network, or the socket has been gone for 10 seconds; `waiting` changes
 * of this restaurant not sent yet (they go by themselves); `failed` ones the
 * server refused, shown where they were made (the order, the KOT) with Try
 * again and Discard.
 */
export function useOfflineStatus() {
	const connection = useConnectionStatus();
	const online = useNetworkOnline();
	const { entries } = useOutbox();
	const restaurantId = useRestaurantId();
	const counts = outboxCounts(entries, restaurantId);
	return { offline: !online || connection.offline, ...counts };
}
